import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { BsArrowLeft, BsChatSquareDotsFill } from 'react-icons/bs';
import { AiOutlineInfoCircle } from 'react-icons/ai';

function SliderInfinite(props) {
    const [circlePosition, setCirclePosition] = React.useState(0);
    const [circlePosition2, setCirclePosition2] = React.useState(0);

    const {
        setDificolta,
        setGiocatori,
        setSingoloPlanctonEasy,
        setSingoloGamberoneNormal,
        setInstruction,
        setShowSliderInfinite,
        setMultipleDifficolta,

    } = props;

    const handleNumberClick = (index) => {
        if (index === 5) {
            setCirclePosition(100);
            localStorage.removeItem('selectedTime'); // Remove the existing selectedTime value
        } else {
            const targetLeft = index * 20;
            setCirclePosition(targetLeft);
            const selectedTime = [60, 75, 90, 105, 120][index]; // Time in seconds
            localStorage.setItem('selectedTime', selectedTime.toString());
        }
        console.log(localStorage.getItem('selectedTime'));
    };

    const handleNumberClick2 = (index) => {
        if (index === 5) {
            setCirclePosition2(100);
            localStorage.removeItem('selectedSecond'); // Remove the existing selectedSecond value
        } else {
            let targetLeft;
            if (index === 4) {
                targetLeft = index * 19;
            } else {
                targetLeft = index * 18.4;
            }
            setCirclePosition2(targetLeft);
            const selectedSecond = [4, 6, 8, 10, 12][index];
            localStorage.setItem('selectedSecond', selectedSecond.toString());
        }
        console.log(localStorage.getItem('selectedSecond'));
    };

    const handleSlider = () => {
        setShowSliderInfinite(false);
    };
    const handleback = () => {
        setDificolta(false);
        setMultipleDifficolta(false)

    };
    const gioca = () => {
        
        setInstruction(true)
    }
    return (
        <div className="sliderinfinte_container">
            <div className="difficolta_header">
                <BsArrowLeft className="header_icon" onClick={handleback} />
                    <AiOutlineInfoCircle className='header_icon' color='black' onClick={gioca} />
            </div>
            <div className="main_div">
                <div className="difficolta_heading_div">
                    <h1 className="difficolta_heading">
                        Se vuoi, puoi personalizzare le durate dei timer a tua scelta
                    </h1>
                    <div className="Timerdella_section">
                        <span className="TimerdellaParagraph">Timer della domanda</span>{' '}
                        <span className="secondi">(secondi)</span>
                        <div className="Linetimer">
                            <div className="timer_numbers timer_numbers2">
                                <span className="timer_number number4" >4</span>
                                <span className="timer_number number6" >6</span>
                                <span className="timer_number number8" >8</span>
                                <span className="timer_number number10" >10</span>
                                <span className="timer_number number12" >12</span>
                                <span className="timer-number infinit" style={{ fontSize: '30px', cursor: 'pointer' }} >&#8734;</span>
                            </div>
                        </div>
                         <Slider
                                defaultValue={0}
                                aria-label="Timer della domanda"
                                marks
                                step={1}
                                min={0}
                                max={5}
                                onChange={(event, value) => handleNumberClick2(value)}
                                valueLabelDisplay="off"
                                valueLabelFormat={(value) => [4, 6, 8, 10, 12, '∞'][value]}
                            />
                             <div className="timer-line"></div>
                            <div className="timer-circle"></div>
                        <div className="Equilibrato_text_div">
                            <p className="Equilibrato_text">Equilibrato per questa difficoltà</p>
                        </div>
                    </div>
                    <div className="Timerdella_section">
                        <span className="TimerdellaParagraph">Timer della domanda</span>{' '}
                        <span className="secondi">(minuti)</span>
                        <div className="Linetimer">
                            <div className="timer_numbers">
                                <span className="timer_number timeMin1" >1:00</span>
                                <span className="timer_number timeMin2" >1:15</span>
                                <span className="timer_number timeMin3" >1:30</span>
                                <span className="timer_number timeMin4" >1:45</span>
                                <span className="timer_number timeMin5" >2:00</span>
                                <span className="timer-number infinit" style={{ fontSize: '30px', cursor: 'pointer' }} >&#8734;</span>
                            </div>
                         
                        </div>   <Slider
                                defaultValue={0}
                                aria-label="Timer della domanda"
                                marks
                                step={1}
                                min={0}
                                max={5}
                                onChange={(event, value) => handleNumberClick(value)}
                                valueLabelDisplay="off"
                                valueLabelFormat={(value) => [60, 75, 90, 105, 120, '∞'][value]}
                            />
                            <div className="timer-line"></div>
                            <div className="timer-circle"></div>
                        <div className="Equilibrato_text_div">
                            <p className="Equilibrato_text">Equilibrato per questa difficoltà</p>
                        </div>
                    </div>
                    <div className="Continua_btn_div">
                        <button className="Continua_btn" onClick={handleSlider}>
                            Continua
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SliderInfinite;
